import log from 'loglevel'

type AllowedLevels = 'debug' | 'error' | 'warn' | 'info' | 'trace' | 'silent'
let logLevel: AllowedLevels = 'debug'

if (process.env.NODE_ENV === 'development') {
  logLevel = 'debug' // Verbose logging in development
} else {
  logLevel = 'error' // Only log errors in production
}

log.setLevel(logLevel)

export { log }
